import {makeStyles, DefaultTheme} from '@mui/styles';

interface CheckBoxObj {
  status: string[];
  checked: boolean;
}

export const useStyles = makeStyles<DefaultTheme, CheckBoxObj>({
  dcrContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  downloadExcelLogo: {
    width: 25,
    marginRight: 5,
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'end',
  },
  dropdown: {
    backgroundColor: '#f2f2f2',
    height: 40,
  },
  buttonGroup: {
    alignSelf: 'end',
    height: 40,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#332b77',
  },
  btn: {
    backgroundColor: '#332b77',
    // width: 60,
    borderRadius: 20,
  },
  root: {
    width: '180px',
    height: '40px',
    padding: '2px',
  },
  switchBase: {
    color: '#818181',
    padding: '1px',
    '&$checked': {
      '& + $track': {
        backgroundColor: '#fff',
      },
    },
  },
  thumb: statusSelected => {
    return {
      color: '#fff',
      backgroundColor: '#332b77',
      width: '90px',
      height: '36px',
      margin: '0px',
      borderRadius: 20,

      left: '9px',
      '&:after, &:before': {
        color: '#fff',
        fontSize: '14px',
        position: 'absolute',
        top: '8px',
      },
      '&:after': {
        content: statusSelected.checked
          ? `'${statusSelected?.status[1]}'`
          : `'${statusSelected?.status[0]}'`,
        left: '15px',
      },
    };
  },
  track: statusSelected => {
    return {
      borderRadius: '20px',
      color: '#fff',
      backgroundColor: '#fff!important',
      opacity: '1 !important',
      '&:after, &:before': {
        color: '#000',
        fontSize: '14px',
        position: 'absolute',
        top: '9px',
      },
      '&:after': {
        content: `'${statusSelected?.status[0]}'`,
        left: '20px',
      },
      '&:before': {
        content: `'${statusSelected?.status[1]}'`,
        right: '15px',
      },
    };
  },
  checked: {
    color: '#23bf58 !important',
    transform: 'translateX(88px) !important',
  },
});
